module.exports = __webpack_public_path__ + "img/gsb41.c208aadd.png";